export default __webpack_public_path__ + "static/media/hotel.07529fc6.png";